export interface DashboardFilters {
    q: string;
    cat: string;
}
export const DASHBOARD_STORAGE_KEY = "home:filters";
export const DEFAULT_DASHBOARD_FILTERS: DashboardFilters = { q: "", cat: "active-not-ack" };

export function parseStoredDashboardFilters(raw: string | null): DashboardFilters {
    if (!raw) return { ...DEFAULT_DASHBOARD_FILTERS };
    const value: unknown = JSON.parse(raw);
    if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("Saved dashboard filters must be an object");
    const record = value as Record<string, unknown>;
    if ((record.q !== undefined && typeof record.q !== "string") || (record.cat !== undefined && typeof record.cat !== "string")) {
        throw new Error("Saved dashboard filter values must be text");
    }
    return {
        q: typeof record.q === "string" ? record.q : "",
        cat: typeof record.cat === "string" ? record.cat : "active-not-ack",
    };
}

export function resolveDashboardFilters(params: URLSearchParams, fallback = DEFAULT_DASHBOARD_FILTERS): DashboardFilters {
    return { q: params.get("q") ?? fallback.q, cat: params.get("cat") ?? fallback.cat };
}

export function applyDashboardFilters(params: URLSearchParams, filters: DashboardFilters): URLSearchParams {
    const next = new URLSearchParams(params);
    if (filters.q.trim()) next.set("q", filters.q.trim());
    else next.delete("q");
    if (filters.cat && filters.cat !== "all") next.set("cat", filters.cat);
    else next.delete("cat");
    return next;
}
